"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _MapSourceModule = require("../../MapSourceModule");

var _index = require("../../../utils/index");

var _utils = require("../utils");

var _units = require("../../../utils/units");

var _strings = require("../../../utils/strings");

require("../styles/systems.scss");

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var Systems =
/** @class */
function (_super) {
  __extends(Systems, _super);

  function Systems() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(Systems.prototype, "id", {
    get: function () {
      return this.opts.id || 'tropical-systems';
    },
    enumerable: false,
    configurable: true
  });

  Systems.prototype.source = function () {
    var properties = {
      id: 'id',
      category: 'details.stormCat',
      timestamp: 'timestamp',
      points: ['track', 'forecast'],
      path: 'errorCone'
    };
    return {
      type: 'vector',
      data: {
        request: {
          endpoint: 'tropicalcyclones/archive',
          action: "search"
          /* SEARCH */
          ,
          parameters: {
            filter: 'active,geo',
            limit: 50
          }
        },
        properties: properties,
        formatter: function (data) {
          return (0, _utils.formatStormData)(data);
        }
      },
      style: {
        marker: function (data) {
          return (0, _utils.getStormMarkerConfig)(data);
        },
        polygon: function (data) {
          return {
            fill: {
              color: '#ffffff',
              opacity: 0.7
            }
          };
        },
        polyline: function (data) {
          var type = (0, _index.get)(data, 'details.stormCat');
          return {
            adjustOpacity: false,
            stroke: {
              color: (0, _utils.color)(type),
              width: 3
            }
          };
        }
      },
      animation: {
        enabled: true
      }
    };
  };

  Systems.prototype.controls = function () {
    return {
      value: this.id,
      title: 'Cyclones',
      filter: true,
      multiselect: false,
      segments: [{
        title: 'Active Cyclones',
        value: 'active,geo'
      }, {
        title: 'All Cyclones',
        value: 'active;notactive,geo'
      }]
    };
  };

  Systems.prototype.legend = function () {
    return {
      title: 'Tropical Cyclones',
      code: 'tropical-cyclones'
    };
  };

  Systems.prototype.infopanel = function () {
    return {
      views: [{
        renderer: function (data) {
          if (!(0, _index.isset)(data) || (0, _index.isEmpty)(data)) return null;
          if ((0, _index.isEmpty)(data.details) || (0, _index.isEmpty)(data.profile)) return null;
          var category = (0, _index.get)(data, 'details.stormCat');

          var _a = (0, _index.get)(data, 'location.coordinates'),
              lon = _a[0],
              lat = _a[1];

          var startTime = (0, _index.get)(data, 'profile.lifespan.startTimestamp');
          var endTime = (0, _index.get)(data, 'profile.lifespan.endTimestamp');
          var metric = data.units === "metric"
          /* Metric */
          ;
          var advisoryInfo = [];
          var advisoryNumber = (0, _index.get)(data, 'details.advisoryNumber');
          var advisoryTimestamp = data.timestamp;

          if ((0, _index.isset)(advisoryNumber)) {
            advisoryInfo.push("Advisory #" + advisoryNumber);
          }

          if ((0, _index.isset)(data.timestamp)) {
            advisoryInfo.push((0, _index.formatDate)(new Date(advisoryTimestamp * 1000), 'h:mm a, MMM d, yyyy'));
          }

          return "\n\t\t\t\t\t\t<div class=\"awxjs__tropical-system awxjs__tropical-system-profile\">\n\t\t\t\t\t\t\t<div class=\"awxjs__tropical-system-profile__header awxjs__ui-row\">\n\t\t\t\t\t\t\t\t<div class=\"awxjs__tropical-system-profile__icon\">\n\t\t\t\t\t\t\t\t\t<img src=\"" + (0, _utils.icon)(category) + "\">\n\t\t\t\t\t\t\t\t\t" + (/^H/.test(category) ? "<div class=\"awxjs__tropical-system-profile__icon-label\">" + category.replace(/^H/, '') + "</div>" : '') + "\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"awxjs__tropical-system-profile__metadata\">\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__tropical-system-profile__name\">" + (0, _index.get)(data, 'details.stormName') + "</div>\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__tropical-system-profile__timestamp\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"timestamp\">\n\t\t\t\t\t\t\t\t\t\t\t" + (data.isForecast ? 'Forecast' : advisoryInfo.join(' - ')) + "\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"awxjs__tropical-system-profile__details\">\n\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-row\">\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand label\">Basin</div>\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand value\">" + (0, _index.get)(data, 'details.basin') + "</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-row\">\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand label\">Location</div>\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand value\">" + (lat && lon ? (0, _strings.toCoord)(lat, lon, 1) : 'N/A') + "</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-row\">\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand label\">Moving</div>\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand value\">\n\t\t\t\t\t\t\t\t\t" + ((0, _index.get)(data, 'details.movement.speedMPH') === 0 ? "Stationary" : "\n\t\t\t\t\t\t\t\t\t\t" + ((0, _index.get)(data, 'details.movement.direction') || '') + "\n\t\t\t\t\t\t\t\t\t\t" + (0, _units.formatDataValue)(data, 'details.movement.speedMPH', 'details.movement.speedKPH', metric) + "\n\t\t\t\t\t\t\t\t\t") + "\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-row\">\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand label\">Winds</div>\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand value\">" + ((0, _index.get)(data, 'details.windSpeedMPH') > 0 ? "\n\t\t\t\t\t\t\t\t\t\t" + (0, _units.formatDataValue)(data, 'details.windSpeedMPH', 'details.windSpeedKPH', metric) + "&nbsp;\n\t\t\t\t\t\t\t\t\t\t" + ((0, _index.get)(data, 'details.gustSpeedMPH') > 0 ? "(" + (0, _units.formatDataValue)(data, 'details.gustSpeedMPH', 'details.gustSpeedKPH', metric) + " gusts)" : '') + "\n\t\t\t\t\t\t\t\t\t" : "Calm") + "</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-row\">\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand label\">Pressure</div>\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand value\">" + (0, _units.formatDataValue)(data, 'details.pressureIN', 'details.pressureMB', metric) + "</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"awxjs__tropical-system-profile__summary\">\n\t\t\t\t\t\t\t\t" + ((0, _index.isset)(startTime) ? "\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-row\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand label\">Lifespan</div>\n\t\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand value\">\n\t\t\t\t\t\t\t\t\t\t\t" + (0, _index.formatDate)(new Date(startTime * 1000), 'L/d/yyyy') + ' - ' + "\n\t\t\t\t\t\t\t\t\t\t\t" + ((0, _index.isset)(endTime) ? (0, _index.formatDate)(new Date(endTime * 1000), 'L/d/yyyy') : '') + "\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t" : '') + "\n\t\t\t\t\t\t\t\t" + ((0, _index.get)(data, 'profile.windSpeed.maxMPH') > 0 ? "\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-row\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand label\">Max Winds</div>\n\t\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand value\">\n\t\t\t\t\t\t\t\t\t\t\t" + (0, _units.formatDataValue)(data, 'profile.windSpeed.maxMPH', 'profile.windSpeed.maxKPH', metric) + "\n\t\t\t\t\t\t\t\t\t\t\ton " + (0, _index.formatDate)(new Date((0, _index.get)(data, 'profile.windSpeed.maxTimestamp') * 1000), 'L/d/yyyy') + "\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t" : '') + "\n\t\t\t\t\t\t\t\t" + ((0, _index.get)(data, 'profile.pressure.minIN') > 0 ? "\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-row\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand label\">Min Pressure</div>\n\t\t\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand value\">\n\t\t\t\t\t\t\t\t\t\t\t" + (0, _units.formatDataValue)(data, 'profile.pressure.minIN', 'profile.pressure.minMB', metric) + "\n\t\t\t\t\t\t\t\t\t\t\ton " + (0, _index.formatDate)(new Date((0, _index.get)(data, 'profile.pressure.minTimestamp') * 1000), 'L/d/yyyy') + "\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t" : '') + "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t";
        }
      }]
    };
  };

  Systems.prototype.onInit = function () {// Perform custom actions when the module has been initialized with a map application
    // instance.
  };

  Systems.prototype.onAdd = function () {// Perform custom actions when the module's map source has been added to the map and is
    // active.
  };

  Systems.prototype.onRemove = function () {// Perform custom actions when the module's map source has been removed from the map and
    // is no longer active.
  };

  Systems.prototype.onMarkerClick = function (marker, data) {
    this.showInfoPanel(data.profile.name, data);
  };

  Systems.prototype.onShapeClick = function (shape, data) {// Perform custom actions when a vector shape object associated with the module's map
    // source was clicked on the map. You can use this method to perform additional actions or
    // to display the info panel for the module with the shape's data, e.g.:
    //
    // this.showInfoPanel(`Outlook`, data);
  };

  return Systems;
}(_MapSourceModule.BaseMapSourceModule);

var _default = Systems;
exports.default = _default;
module.exports = exports.default;